//----- Component --------------------------------------------------------/

// Developer : Nicolas Pascucci

// Creation Date : 28/12/2024

// Version : 1

// Description : ASIGNACION DE EQUIPO A LOS EMPLEADOS DE LA SUCURSAL
//

//------Changes --------------------------------------------------------------------- -------------//

// Change Date :

// Change by :

// Change description:

//

// Change Date :

// Change by :

// Change description:

//
//========================================================================/
import React, { useCallback, useMemo } from "react";
import { useEffect, useState } from "react";
import {
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  Autocomplete,
  Tooltip,
  IconButton,
  Grid,
  CircularProgress,
} from "@mui/material";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Notify from "../../Notify";
import { Delete, AddCircleOutline } from "@mui/icons-material";
import { getData } from "../../../services/library";
import { UrlApi } from "../../../services/apirest";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";
import ConfirmacionModal from "./ConfirmacionModal";
import ModalSeleccionEmpresa from "./ModalSeleccionEmpresa";

// Componente memorizado para el TextField de Elementos de Trabajo
const ElementosTrabajoInput = React.memo(({ value, onChange }) => {
  return (
    <TextField
      fullWidth
      label="Elementos Necesarios"
      name="elementos_trabajo"
      size="small"
      placeholder="..."
      inputProps={{ maxLength: 200 }}
      focused
      required
      value={value}
      onChange={onChange}
    />
  );
});

// Componente memorizado para la lista de empleados seleccionados
const EmpleadosSeleccionadosList = React.memo(
  ({ empleadosFiltrados, handleEliminarEmpleado }) =>
    empleadosFiltrados.map((empleado, index) => (
      <Box
        key={`${empleado.id}-${index}`}
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "10px",
        }}
      >
        <Typography fontSize={16}>
          {empleado.nombre} {empleado.apellido} - Legajo: {empleado.nro_legajo}
        </Typography>
        <Button
          size="small"
          variant="outlined"
          color="error"
          onClick={() => handleEliminarEmpleado(index)}
        >
          Eliminar
        </Button>
      </Box>
    ))
);

function Asignar_equipo(props) {
  const style = {
    backgroundColor: "#ffffff",
    width: "100%",
  };
  const [notificacion, setNotificacion] = useState({
    open: false,
    mensaje: "",
    severity: "",
    color: "",
  });
  const [uuid, setUuid] = useState(uuidv4());
  const fecha = moment(new Date()).format("YYYY-MM-DD");
  const [artSuc, setArtSuc] = useState(props.artSuc);
  const [articulos, setArticulos] = useState();
  const [empleados, setEmpleados] = useState([]);
  const [empleadosTotal, setEmpleadosTotal] = useState([]);
  const [empleadoSeleccionado, setEmpleadoSeleccionado] = useState("");
  const [datosRenglon, setDatosRenglon] = useState([
    {
      uuid_ficha: uuid,
      id_articulo: null,
      id_almacen: null,
      cantidad: 1,
      fecha: moment(new Date()).format("YYYY-MM-DD"),
      tiene_talles: null,
      tipo_prenda: null,
    },
  ]);
  console.log(fecha);

  const [almacenes, setAlmacenes] = useState(props.almacenes);
  const [cantidadesActualizadas, setCantidadesActualizadas] = useState(
    datosRenglon.map((linea) => linea.cantidad)
  );
  const [empleadosSeleccionados, setEmpleadosSeleccionados] = useState([]);
  const [hayError, setHayError] = useState(false); // Para habilitar/deshabilitar el botón de guardar
  const [erroresStock, setErroresStock] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [filtrando, setFiltrando] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [loading, setLoading] = useState(false);
  // Estados para controlar el modal
  const [mostrarModal, setMostrarModal] = useState(false);
  const [empleadosSinStockModal, setEmpleadosSinStockModal] = useState([]);
  const [empleadosConStockModal, setEmpleadosConStockModal] = useState([]);

  // Agregar linea de articulos
  const agregarLinea = () => {
    const nuevaLinea = {
      uuid_ficha: uuid,
      id_articulo: null,
      id_almacen: null,
      cantidad: 1,
      fecha: moment(new Date()).format("YYYY-MM-DD"),
      tiene_talles: null,
      tipo_prenda: null,
    };
    setDatosRenglon((prevLineas) => [...prevLineas, nuevaLinea]);
    setAlmacenesDisponibles([...almacenesDisponibles, []]);
  };

  const guardar = async (e) => {
    try {
      console.log("Iniciando guardar...");
      setDisabled(true);
      setLoading(true); // Activa el estado de carga
      const stockTalles = await obtenerStock(datosRenglon);
      const cantidadPorTalle = {};
      const empleadosSinStock = {};
      const empleadosConStock = [];

      empleadosSeleccionados.forEach((empleado) => {
        let tieneStock = true;
        let tieneTalle = true;
        datosRenglon.forEach((renglon) => {
          const talleEmpleado = obtenerTalleEmpleado(empleado, renglon);

          const key = `${renglon.id_almacen}-${renglon.id_articulo}-${talleEmpleado}`;

          if (!cantidadPorTalle[key]) {
            cantidadPorTalle[key] = { cantidad: 0, renglon, talleEmpleado };
          }
          cantidadPorTalle[key].cantidad += renglon.cantidad;

          const talleStock = stockTalles.find(
            (t) =>
              t.articulo === renglon.id_articulo &&
              t.almacen === renglon.id_almacen &&
              t.talle === Number(talleEmpleado)
          );

          if (!talleStock) {
            tieneTalle = false;
            const nombreArticulo = obtenerNombreArticulo(renglon.id_articulo);
            const xtalle = renglon.tiene_talles;
            if (!empleadosSinStock[nombreArticulo]) {
              empleadosSinStock[nombreArticulo] = [];
            }
            empleadosSinStock[nombreArticulo].push({
              nombre: `${empleado.nombre} ${empleado.apellido}`,
              talle: talleEmpleado || "no registrado",
              xtalle: xtalle,
            });
          }
        });

        if (tieneStock && tieneTalle) {
          empleadosConStock.push(empleado);
        }
      });
      if (Object.keys(empleadosSinStock).length > 0) {
        setMostrarModal(true);
        setEmpleadosSinStockModal(empleadosSinStock);
        setEmpleadosConStockModal(empleadosConStock);
        return;
      }

      await continuarGuardado(empleadosConStock);
    } catch (error) {
      console.error("Error general al guardar:", error);
    } finally {
    }
  };

  // fichas todas al mismo teiempo
  const guardarFichasYDetalles = async (empleadosConStock) => {
    const usuario = localStorage.getItem("user");
    const fichas = [];
    const renglones = [];

    for (const empleado of empleadosConStock) {
      const nuevoUuid = uuidv4();

      // Agregar la ficha
      fichas.push({
        empleado: empleado.id,
        empresa: empleado.idempresa,
        sucursal: empleado.sucursal,
        elementos_trabajo: elementosTrabajo,
        fecha: fecha,
        uuid_ficha: nuevoUuid,
        usuario,
      });

      // Agregar todos los renglones de esta ficha
      for (const renglon of datosRenglon) {
        renglones.push({
          uuid_ficha: nuevoUuid,
          id_articulo: renglon.id_articulo,
          cantidad: renglon.cantidad,
          fecha: renglon.fecha,
          usuario,
          talle: obtenerTalleEmpleado(empleado, renglon),
        });
      }
    }

    // Enviar TODO en una sola petición
    const response = await fetch(
      UrlApi + "/stock_ficha_rrhh/stock_fichas_completas",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ fichas, renglones }),
      }
    );

    if (!response.ok) {
      throw new Error("Error al guardar fichas y renglones");
    }
  };

  const continuarGuardado = async (empleadosConStock) => {
    await guardarFichasYDetalles(empleadosConStock);
    await guardarTransacciones(empleadosConStock); // este ya lo hiciste agrupado también

    await Promise.all([
      actualizarInventarioGeneral(empleadosConStock),
      actualizarStockPorTalles(empleadosConStock),
    ]);
    handleClose();
  };

  // Función para manejar la decisión del usuario
  const handleDecisionModal = (decision) => {
    setMostrarModal(false);
    if (decision === "continuar") {
      continuarGuardado(empleadosConStockModal);
    }
    if (decision === "cancelar") {
      setLoading(false);
      setDisabled(false);
    }
  };

  const obtenerNombreArticulo = (idArticulo) => {
    const articulo = articulos.find((art) => art.id_articulo === idArticulo);
    return articulo ? articulo.nombre : "Artículo desconocido";
  };

  const guardarTransacciones = async (empleadosConStock) => {
    const usuario = localStorage.getItem("user");
    const fecha = moment().format("YYYY-MM-DD HH:mm:ss");

    for (const renglon of datosRenglon) {
      if (renglon.id_articulo && renglon.id_almacen && renglon.cantidad > 0) {
        const cantidadTotal = renglon.cantidad * empleadosConStock.length;

        await fetch(UrlApi + "/stock_transacciones", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id_accion: 200,
            id_articulo: renglon.id_articulo,
            almacen_origen: renglon.id_almacen,
            cantidad_enviada: cantidadTotal,
            fecha_transaccion: fecha,
            usuario,
          }),
        });
      }
    }
  };

  const actualizarInventarioGeneral = async (empleadosConStock) => {
    await Promise.all(
      datosRenglon.map(async (renglon) => {
        const nuevaCantidad =
          renglon.cantidadInventario -
          renglon.cantidad * empleadosConStock.length;
        await fetch(UrlApi + "/stock_inventarios/" + renglon.id_inventario, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            cantidad: nuevaCantidad,
            usuario: localStorage.getItem("user"),
          }),
        });
      })
    );
  };

  const actualizarStockPorTalles = async (empleadosConStock) => {
    const stockTalles = await obtenerStock(datosRenglon);
    const cantidadPorTalle = {};

    empleadosConStock.forEach((empleado) => {
      datosRenglon.forEach((renglon) => {
        const talleEmpleado = obtenerTalleEmpleado(empleado, renglon);
        const key = `${renglon.id_almacen}-${renglon.id_articulo}-${talleEmpleado}`;

        if (!cantidadPorTalle[key]) {
          cantidadPorTalle[key] = { cantidad: 0, renglon, talleEmpleado };
        }
        cantidadPorTalle[key].cantidad += renglon.cantidad;
      });
    });

    await Promise.all(
      Object.values(cantidadPorTalle).map(
        async ({ renglon, talleEmpleado, cantidad }) => {
          const talleStock = stockTalles.find(
            (t) =>
              t.articulo === renglon.id_articulo &&
              t.almacen === renglon.id_almacen &&
              t.talle === Number(talleEmpleado)
          );
          if (talleStock) {
            const nuevaCantidad = talleStock.cantidad - cantidad;
            await fetch(
              `${UrlApi}/stock_prendas/bajastock/${renglon.id_almacen}/${renglon.id_articulo}/${talleEmpleado}`,
              {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  cantidad: nuevaCantidad,
                  usuario: localStorage.getItem("user"),
                }),
              }
            );
          }
        }
      )
    );
    console.log("Finalizando guardar. Restaurando estados...");
    setLoading(false);
    setDisabled(false);
  };

  const obtenerTalleEmpleado = (empleado, renglon) => {
    switch (renglon.tipo_prenda) {
      case 1:
        return empleado.remera;
      case 2:
        return empleado.pantalon;
      case 3:
        return empleado.botin;
      case 4:
        return empleado.faja;
      case 5:
        return empleado.buzo;
      case 6:
        return empleado.campera;
      default:
        return null;
    }
  };

  const stockTalles = [];

  const obtenerStock = async (datosRenglon) => {
    try {
      // Recorrer todos los renglones para obtener el stock de cada artículo y almacén
      for (const renglon of datosRenglon) {
        if (renglon.id_articulo && renglon.id_almacen) {
          const response = await fetch(
            UrlApi +
              "/stock_prendas/detalle/" +
              renglon.id_almacen +
              "/" +
              renglon.id_articulo
          );

          if (!response.ok) {
            throw new Error(
              `Error al obtener stock para artículo ${renglon.id_articulo} y almacén ${renglon.id_almacen}`
            );
          }

          const data = await response.json(); // Convertir la respuesta a JSON
          if (Array.isArray(data)) {
            stockTalles.push(...data); // Agregar los datos al array stockTalles
          }
        }
      }
      return stockTalles; // Devolver el array con todos los datos
    } catch (error) {
      console.error("Error al obtener stock:", error);
      return []; // Devolver un array vacío en caso de error
    }
  };
  const obtenerAlmacenesConStock = async (idSucursal, idArticulo) => {
    try {
      const response = await fetch(
        `${UrlApi}/stock_almacenes/xsucursalarticulorrhh/${idSucursal}/${idArticulo}`
      );

      if (!response.ok) {
        throw new Error(`Error HTTP: ${response.status}`);
      }

      const data = await response.json();
      return data || [];
    } catch (error) {
      console.error("Error al obtener almacenes con stock:", error);
      return [];
    }
  };

  // const handleProductoChange = (index, value) => {
  //   const nuevasLineas = [...datosRenglon];
  //   nuevasLineas[index].id_articulo = value ? value.id_articulo : null;
  //   nuevasLineas[index].tipo_prenda = value ? value.tipo_prenda : null;
  //   nuevasLineas[index].tiene_talles = value ? value.tiene_talles : null;
  //   setDatosRenglon(nuevasLineas);

  //   if (value && value.tiene_talles === 1) {
  //     // Si el artículo tiene talles, obtener el stock por talles
  //     obtenerStock(datosRenglon);
  //   }

  //   resta();
  // };
  const [almacenesDisponibles, setAlmacenesDisponibles] = useState([]);
  const handleProductoChange = async (index, value) => {
    // 1. Actualizar los datos básicos del artículo
    const nuevasLineas = [...datosRenglon];
    nuevasLineas[index].id_articulo = value ? value.id_articulo : null;
    nuevasLineas[index].tipo_prenda = value ? value.tipo_prenda : null;
    nuevasLineas[index].tiene_talles = value ? value.tiene_talles : null;
    nuevasLineas[index].articulo = value; // Guardar el objeto completo del artículo
    nuevasLineas[index].almacen = null; // Resetear el almacén al cambiar artículo

    setDatosRenglon(nuevasLineas);

    // 2. Obtener almacenes con stock si hay artículo y sucursal
    if (value && props.sucursal) {
      try {
        const almacenesConStock = await obtenerAlmacenesConStock(
          props.sucursal,
          value.id_articulo
        );

        // Actualizar los almacenes disponibles para este renglón
        setAlmacenesDisponibles((prev) => {
          const newAlmacenes = [...prev];
          newAlmacenes[index] = almacenesConStock;
          return newAlmacenes;
        });

        // Mostrar mensaje si no hay stock
        // if (almacenesConStock.length === 0) {
        //   setErroresStock(prev => {
        //     const newErrores = [...prev];
        //     newErrores[index] = "No hay almacenes con stock disponible para este artículo";
        //     return newErrores;
        //   });
        // } else {
        //   // Limpiar error si hay stock
        //   setErroresStock(prev => {
        //     const newErrores = [...prev];
        //     newErrores[index] = "";
        //     return newErrores;
        //   });
        // }
      } catch (error) {
        console.error("Error al obtener almacenes con stock:", error);
        // setErroresStock(prev => {
        //   const newErrores = [...prev];
        //   newErrores[index] = "Error al verificar stock";
        //   return newErrores;
        // });
      }
    }

    // 3. Lógica original para artículos con talles
    if (value && value.tiene_talles === 1) {
      obtenerStock(datosRenglon);
    }

    // 4. Llamar a resta (función existente)
    resta();
  };

  const handleAlmacenChange = (index, value) => {
    const nuevasLineas = [...datosRenglon];
    nuevasLineas[index].id_almacen = value ? value.id_almacen : null;
    setDatosRenglon(nuevasLineas);

    // Verificar si el artículo tiene talles y obtener el stock
    const articulo = articulos.find(
      (articulo) => articulo.id_articulo === nuevasLineas[index].id_articulo
    );

    if (articulo && articulo.tiene_talles === 1 && value) {
      obtenerStock(datosRenglon);
    }
    resta();
  };

  const handleCantidadChange = (index, value) => {
    const nuevasLineas = [...datosRenglon];
    nuevasLineas[index].cantidad = value;
    setDatosRenglon(nuevasLineas);
    resta();
  };

  const handleFechaChange = (index, value) => {
    const nuevasLineas = [...datosRenglon];
    nuevasLineas[index].fecha = value;
    setDatosRenglon(nuevasLineas);
  };

  const [elementosTrabajo, setElementosTrabajo] = useState("");
  const handleElementosTrabajoChange = useCallback((e) => {
    setElementosTrabajo(e.target.value);
  }, []);

  const deshacerAlmacenar = (index) => {
    const nuevasLineas = datosRenglon.filter((_, i) => i !== index);
    // Actualiza el estado con las nuevas líneas
    setDatosRenglon(nuevasLineas);
    const nuevasCantidades = nuevasLineas.map((linea) => linea.cantidadSalida);
    setCantidadesActualizadas(nuevasCantidades);
    // Si necesitas hacer una resta o cualquier otra acción aquí, puedes hacerlo
    setErroresStock((prev) => {
      const { [index]: _, ...rest } = prev;
      return rest;
    });
    setHayError(false);
    const newAlmacenesDisponibles = [...almacenesDisponibles];
    newAlmacenesDisponibles.splice(index, 1);
    setAlmacenesDisponibles(newAlmacenesDisponibles);
  };

  useEffect(() => {
    getData(
      "/stock_ficha_rrhh/empleadosxsucursal/" + props.sucursal,
      setEmpleados
    );
    getData("/stock_almacenes/xsucursal/" + props.sucursal, setAlmacenes);
    getData("/stock_articulos/articulosxsector/3", setArticulos);
  }, []);

  const handleClose = () => {
    props.onClose(true);
  };

  // ************************** Baja de inventario **********************************//
  const hayErrorRenglones = datosRenglon.some(
    (renglon) =>
      !renglon.id_articulo || !renglon.id_almacen || !renglon.cantidad
  );

  // Memorizar función de resta
  const resta = useCallback(() => {
    const nuevasCantidades = datosRenglon.map((linea) => {
      const itemInventario = artSuc.find(
        (item) =>
          item.id_articulo === linea.id_articulo &&
          item.id_almacen === linea.id_almacen
      );
      return itemInventario
        ? itemInventario.cantidad - linea.cantidad
        : linea.cantidad;
    });

    setCantidadesActualizadas(nuevasCantidades);

    const nuevasLineas = datosRenglon.map((linea) => {
      const itemInventario = artSuc.find(
        (item) =>
          item.id_articulo === linea.id_articulo &&
          item.id_almacen === linea.id_almacen
      );

      return itemInventario
        ? {
            ...linea,
            cantidadSalida: itemInventario.cantidad - linea.cantidad,
            id_inventario: itemInventario.id_inventario,
            cantidadInventario: itemInventario.cantidad,
          }
        : linea;
    });

    setDatosRenglon(nuevasLineas);
  }, [datosRenglon, artSuc]);

  const handleEmpleadoSeleccionado = useCallback(
    (value) => {
      if (value && !empleadosSeleccionados.some((emp) => emp.id === value.id)) {
        setEmpleadosSeleccionados((prev) => [...prev, value]);
        setEmpleadoSeleccionado(null);
      }
      setFiltrando(false);
    },
    [empleadosSeleccionados]
  );

  const handleEliminarEmpleado = useCallback((index) => {
    setEmpleadosSeleccionados((prev) => prev.filter((_, i) => i !== index));
  }, []);

  const handleSearch = useCallback((e) => {
    setSearchTerm(e.target.value.toLowerCase());
  }, []);

  const empleadosFiltrados = useMemo(() => {
    return empleadosSeleccionados.filter((empleado) =>
      `${empleado.nombre} ${empleado.apellido}`
        .toLowerCase()
        .includes(searchTerm.toLowerCase())
    );
  }, [empleadosSeleccionados, searchTerm]);

  useEffect(() => {
    const hasErrors =
      empleadosSeleccionados.length === 0 ||
      elementosTrabajo === "" ||
      hayErrorRenglones;
    setDisabled(hasErrors);
  }, [
    empleadosSeleccionados,
    elementosTrabajo,
    hayErrorRenglones,
    datosRenglon,
  ]);

  const handleLimpiarYSeleccionarTodos = () => {
    const empleadosNoDuplicados = empleados.filter(
      (empleado, index, self) =>
        index === self.findIndex((e) => e.id === empleado.id)
    );
    setEmpleadosSeleccionados(empleadosNoDuplicados);
  };

  // elegir empleados por empresa
  const [modalEmpresaOpen, setModalEmpresaOpen] = useState(false);
  const [triggerSeleccionarTodos, setTriggerSeleccionarTodos] = useState(false);

  const handleEmpresaSeleccionada = (empresaId) => {
    console.log("Empresa seleccionada ID:", empresaId);
    getData(
      "/stock_ficha_rrhh/empleadosxempresa/" + empresaId,
      setEmpleadosTotal
    );
    setTriggerSeleccionarTodos(true); // activás el disparador
  };

  const handleSeleccionarTodosEmpresa = useCallback(() => {
    const empleadosNoSeleccionados = empleadosTotal.filter(
      (empleado) =>
        !empleadosSeleccionados.some(
          (selectedEmpleado) => selectedEmpleado.id === empleado.id
        )
    );
    setEmpleadosSeleccionados((prev) => [...prev, ...empleadosNoSeleccionados]);
  }, [empleadosTotal, empleadosSeleccionados]);

  console.log("empleadosSeleccionados", empleadosSeleccionados);

  useEffect(() => {
    if (triggerSeleccionarTodos && empleadosTotal.length > 0) {
      handleSeleccionarTodosEmpresa();
      setTriggerSeleccionarTodos(false); // reseteás el trigger
    }
  }, [empleadosTotal, triggerSeleccionarTodos, handleSeleccionarTodosEmpresa]);

  const textoError = datosRenglon
    ? datosRenglon.map((linea, index) => {
        const stock = almacenesDisponibles[index];
        return stock && stock.length > 0 ? "" : "Cargue stock del artículo";
      })
    : [];

  return (
    <>
      <Dialog
        fullWidth
        open={props.open}
        onClose={() => props.onClose(false)}
        maxWidth="xl"
      >
        {notificacion && notificacion.open ? (
          <Notify
            mensaje={notificacion.mensaje}
            open={notificacion.open}
            color={notificacion.color}
            handleClose={() => {
              // props.onClose(false);
              // props.actualizar();
            }}
            severity={notificacion.severity}
          />
        ) : null}
        <Box justifyContent="center" backgroundColor="#1F618D">
          <DialogTitle>
            <Typography fontSize={20} align="center" color="#ffffff">
              Asignar Articulos a Empleado
            </Typography>
          </DialogTitle>
        </Box>
        <form>
          <DialogContent>
            <Grid container spacing={2}>
              <Grid item xs={8}>
                {filtrando === true ? (
                  <TextField
                    disabled
                    focused
                    fullWidth
                    size="small"
                    label="Actualizando..."
                  />
                ) : (
                  <Autocomplete
                    disabled={!empleados}
                    required
                    disableClearable
                    id="empleado"
                    style={style}
                    size="small"
                    noOptionsText={"Empleado INEXISTENTE"}
                    options={empleados.filter(
                      (empleado) =>
                        !empleadosSeleccionados.some(
                          (selectedEmpleado) =>
                            selectedEmpleado.id === empleado.id
                        )
                    )}
                    autoHighlight
                    getOptionLabel={(empleado) =>
                      `${empleado.nro_legajo} - ${empleado.nombre} ${empleado.apellido}`
                    }
                    isOptionEqualToValue={(option, value) =>
                      option.id === value?.id
                    }
                    value={empleadoSeleccionado || null}
                    onChange={(event, value) => {
                      setFiltrando(true);
                      handleEmpleadoSeleccionado(value);
                    }}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        key={option.id}
                        sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                        {...props}
                      >
                        {option.nro_legajo} - {option.nombre} {option.apellido}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        placeholder="Tipee para buscar..."
                        {...params}
                        label="Empleado"
                        focused
                        inputProps={{
                          ...params.inputProps,
                        }}
                      />
                    )}
                  />
                )}
              </Grid>
              <Grid item xs={2}>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={handleLimpiarYSeleccionarTodos}
                  fullWidth
                >
                  Empleados Sucursal
                </Button>
              </Grid>
              <Grid item xs={2}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    setModalEmpresaOpen(true);
                    setEmpleadosTotal([]);
                    setEmpleadosSeleccionados([]);
                  }}
                  fullWidth
                >
                  Empleados Empresa
                </Button>
              </Grid>

              <Grid item xs={12}>
                {empleadosSeleccionados.length > 0 ? (
                  <Box
                    sx={{
                      border: "1px solid #ccc",
                      borderRadius: "5px",
                      padding: "10px",
                      backgroundColor: "#f9f9f9",
                      maxHeight: "150px", // Altura máxima para mostrar tres líneas
                      overflowY: "auto", // Scroll vertical
                    }}
                  >
                    <Grid container>
                      <Grid item xs={6} mb={1}>
                        <Typography
                          fontSize={18}
                          fontWeight="bold"
                          color="#1F618D"
                        >
                          Empleados Seleccionados:
                        </Typography>
                      </Grid>
                      <Grid item xs={6} mb={1}>
                        <TextField
                          fullWidth
                          size="small"
                          type="search"
                          placeholder="Buscar empleado..."
                          value={searchTerm}
                          onChange={handleSearch}
                        />
                      </Grid>
                    </Grid>
                    <EmpleadosSeleccionadosList
                      empleadosFiltrados={empleadosFiltrados}
                      handleEliminarEmpleado={handleEliminarEmpleado}
                    />
                  </Box>
                ) : (
                  <Typography
                    fontSize={16}
                    color="gray"
                    justifyContent={"center"}
                    display={"flex"}
                  >
                    No hay empleados seleccionados.
                  </Typography>
                )}
              </Grid>
              <Grid item xs={12}>
                <ElementosTrabajoInput
                  value={elementosTrabajo}
                  onChange={handleElementosTrabajoChange}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                {empleadosSeleccionados.length !== 0 ? (
                  <Box
                    sx={{
                      border: "1px solid #ccc",
                      borderRadius: "5px",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                      backgroundColor: "#f9f9f9",
                      width: "100%",
                    }}
                  >
                    <Typography
                      fontSize={18}
                      marginTop={1}
                      marginLeft={2}
                      align="left"
                      fontWeight={"bold"}
                    >
                      Seleccione los articulos
                    </Typography>
                    {datosRenglon
                      ? datosRenglon.map((linea, index) => (
                          <div
                            key={index}
                            style={{
                              paddingBottom: "4px",
                              paddingTop: "10px",
                            }}
                          >
                            <Grid container spacing={2}>
                              <Grid item xs={4} ml={1}>
                                {articulos && (
                                  <Autocomplete
                                    disabled={!articulos}
                                    disableClearable
                                    size="small"
                                    required
                                    noOptionsText={"Articulo INEXISTENTE"}
                                    options={articulos}
                                    autoHighlight
                                    getOptionLabel={(articulo) =>
                                      articulo.id_articulo +
                                      "-" +
                                      articulo.nombre +
                                      "-" +
                                      articulo.descripcion
                                    }
                                    onChange={(event, value) => {
                                      handleProductoChange(index, value);
                                    }}
                                    renderOption={(props, option) => (
                                      <Box
                                        component="li"
                                        key={option.id}
                                        sx={{
                                          "& > img": { mr: 2, flexShrink: 0 },
                                        }}
                                        {...props}
                                      >
                                        {option.id_articulo} - {option.nombre} -{" "}
                                        {option.descripcion}
                                      </Box>
                                    )}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        inputProps={{
                                          ...params.inputProps,
                                        }}
                                        focused
                                        size="small"
                                        placeholder="Tipee para buscar..."
                                        label="Articulo"
                                        error={!!erroresStock[index]}
                                      />
                                    )}
                                  />
                                )}
                              </Grid>
                              {/* <Grid item xs={3.5}>
                                {almacenes && (
                                  <Autocomplete
                                    disabled={!almacenes}
                                    size="small"
                                    focused
                                    disableClearable
                                    id="stock_almacenes"
                                    noOptionsText={"Almacén INEXISTENTE"}
                                    options={almacenes}
                                    autoHighlight
                                    getOptionLabel={(almacenes) =>
                                      almacenes.id_almacen +
                                      "-" +
                                      almacenes.nombre
                                    }
                                    onChange={(event, value) => {
                                      handleAlmacenChange(index, value);
                                    }}
                                    renderOption={(props, option) => (
                                      <Box
                                        component="li"
                                        key={option.id}
                                        sx={{
                                          "& > img": { mr: 2, flexShrink: 0 },
                                        }}
                                        {...props}
                                      >
                                        {option.id_almacen} - {option.nombre}
                                      </Box>
                                    )}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        inputProps={{
                                          ...params.inputProps,
                                        }}
                                        focused
                                        size="small"
                                        placeholder="Tipee para buscar..."
                                        label="Almacén"
                                        helperText={erroresStock[index] || ""} // Muestra el mensaje de error si hay
                                        error={!!erroresStock[index]}
                                      />
                                    )}
                                  />
                                )}
                              </Grid> */}
                              <Grid item xs={3.5}>
                                {almacenesDisponibles[index] ? (
                                  <Autocomplete
                                    disabled={
                                      !almacenesDisponibles[index] ||
                                      almacenesDisponibles[index].length === 0
                                    }
                                    size="small"
                                    focused
                                    disableClearable
                                    id={`stock_almacenes_${index}`}
                                    noOptionsText={
                                      !linea.articulo
                                        ? "Seleccione un artículo primero"
                                        : "No hay almacenes con stock disponible"
                                    }
                                    options={almacenesDisponibles[index] || []}
                                    autoHighlight
                                    getOptionLabel={(almacen) =>
                                      `${almacen.id_almacen} - ${almacen.nombre}`
                                    }
                                    onChange={(event, value) => {
                                      handleAlmacenChange(index, value);
                                    }}
                                    renderOption={(props, option) => (
                                      <Box
                                        component="li"
                                        key={option.id_almacen}
                                        sx={{
                                          "& > img": { mr: 2, flexShrink: 0 },
                                        }}
                                        {...props}
                                      >
                                        {option.id_almacen} - {option.nombre}
                                      </Box>
                                    )}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        inputProps={{
                                          ...params.inputProps,
                                        }}
                                        focused
                                        size="small"
                                        placeholder={
                                          !linea.articulo
                                            ? "Seleccione un artículo primero"
                                            : "Seleccione almacén"
                                        }
                                        label="Almacén"
                                        helperText={textoError}
                                        error={!!erroresStock[index]}
                                      />
                                    )}
                                  />
                                ) : (
                                  <TextField
                                    label="Almacén"
                                    placeholder="Almacén"
                                    size="small"
                                    fullWidth
                                  />
                                )}
                              </Grid>
                              <Grid item xs={1}>
                                <TextField
                                  label="Cantidad"
                                  name="cantidad"
                                  size="small"
                                  type="number"
                                  focused
                                  required
                                  fullWidth
                                  autoComplete="off"
                                  value={linea.cantidad || ""}
                                  onChange={(e) =>
                                    handleCantidadChange(index, e.target.value)
                                  }
                                  error={!!erroresStock[index]} // Cambia a rojo si hay error
                                />
                              </Grid>
                              <Grid item xs={2}>
                                <TextField
                                  label="Fecha"
                                  name="fecha"
                                  size="small"
                                  focused
                                  type="date"
                                  required
                                  fullWidth
                                  autoComplete="off"
                                  value={linea.fecha || ""}
                                  onChange={(e) =>
                                    handleFechaChange(index, e.target.value)
                                  }
                                  error={!!erroresStock[index]}
                                />
                              </Grid>
                              <Grid item xs={1} fullWidth>
                                {" "}
                                {/* Columna para los iconos */}
                                {index !== 0 && ( // Solo mostrar el botón si el índice no es 0
                                  <Tooltip title="Eliminar línea">
                                    <IconButton
                                      variant="outlined"
                                      color="error"
                                      onClick={() => deshacerAlmacenar(index)}
                                    >
                                      <Delete />
                                    </IconButton>
                                  </Tooltip>
                                )}
                                {index === datosRenglon.length - 1 && (
                                  <Tooltip title="Agregar línea">
                                    <IconButton
                                      variant="outlined"
                                      color="primary"
                                      onClick={() => {
                                        agregarLinea();
                                      }}
                                    >
                                      <AddCircleOutline />
                                    </IconButton>
                                  </Tooltip>
                                )}
                              </Grid>
                            </Grid>
                          </div>
                        ))
                      : null}
                  </Box>
                ) : null}
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              mt={1}
            >
              <Grid item>
                <Button
                  color="error"
                  variant="outlined"
                  onClick={() => props.onClose(false)}
                  style={{ backgroundColor: "#fff" }}
                >
                  Volver
                </Button>
              </Grid>
              <Grid item>
                <Button
                  color="success"
                  variant="contained"
                  disabled={disabled}
                  onClick={guardar}
                  startIcon={
                    loading ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null
                  }
                >
                  {loading ? "Guardando..." : "Guardar"}
                </Button>
              </Grid>
            </Grid>
            <ConfirmacionModal
              empleadosSinStock={empleadosSinStockModal}
              open={mostrarModal}
              onCancel={() => handleDecisionModal("cancelar")}
              onContinue={() => handleDecisionModal("continuar")}
            />
          </DialogContent>
        </form>
      </Dialog>
      <ModalSeleccionEmpresa
        open={modalEmpresaOpen}
        onClose={() => setModalEmpresaOpen(false)}
        onEmpresaSeleccionada={handleEmpresaSeleccionada}
      />
    </>
  );
}

export default Asignar_equipo;
